document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-mbm-notice]');
  if (!root) return;

  var overlay = root.querySelector('[data-mbm-overlay]');
  var modal = root.querySelector('[data-mbm-modal]');
  var closeBtn = root.querySelector('[data-mbm-close]');
  var tabBtn = root.querySelector('[data-mbm-tab]');

  if (!overlay || !modal || !closeBtn || !tabBtn) return;

  var imageUrl = root.dataset.imageUrl || '';
  var delay = parseInt(root.dataset.delay || '5000', 10);
  var startAt = root.dataset.startAt || '';
  var endAt = root.dataset.endAt || '';

  var LS_DISMISSED = 'mbm_notice_dismissed_v1';
  var LS_AUTOSEEN = 'mbm_notice_autoseen_v1';

  function parseDate(value) {
    if (!value) return null;
    var parsed = new Date(value);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  function withinSchedule() {
    var now = new Date();
    var start = parseDate(startAt);
    var end = parseDate(endAt);

    if (start && now < start) return false;
    if (end && now > end) return false;
    return true;
  }

  function preloadImage(url) {
    if (!url) return;
    var img = new Image();
    img.src = url;
  }

  function openModal() {
    overlay.classList.add('is-active');
    modal.classList.add('is-active');
    tabBtn.classList.remove('is-visible');
  }

  function closeModal(showTab) {
    overlay.classList.remove('is-active');
    modal.classList.remove('is-active');

    if (showTab) {
      tabBtn.classList.add('is-visible');
    }
  }

  function dismissNotice() {
    localStorage.setItem(LS_DISMISSED, 'true');
    closeModal(true);
  }

  if (!withinSchedule()) {
    return;
  }

  preloadImage(imageUrl);

  var dismissed = localStorage.getItem(LS_DISMISSED) === 'true';
  var autoSeen = localStorage.getItem(LS_AUTOSEEN) === 'true';

  if (dismissed) {
    tabBtn.classList.add('is-visible');
  } else if (!autoSeen) {
    localStorage.setItem(LS_AUTOSEEN, 'true');
    window.setTimeout(function () {
      openModal();
    }, delay);
  }

  closeBtn.addEventListener('click', dismissNotice);
  overlay.addEventListener('click', dismissNotice);

  tabBtn.addEventListener('click', function () {
    openModal();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal.classList.contains('is-active')) {
      dismissNotice();
    }
  });
});